import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0bf52a8&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/app/components/app/Breadcrumbs.vue').default,BaseButton: require('/app/components/base/Button.vue').default,CartSubmitButton: require('/app/components/cart/SubmitButton.vue').default,CartEmptyBox: require('/app/components/cart/EmptyBox.vue').default,CartLines: require('/app/components/cart/Lines.vue').default,FormCartPromocode: require('/app/components/form/CartPromocode.vue').default,WidgetsUSP: require('/app/components/widgets/USP.vue').default,CartTotal: require('/app/components/cart/Total.vue').default,BaseOverlay: require('/app/components/base/Overlay.vue').default})
